import React, { useMemo } from 'react'
import { IUser } from '@/api/user/getUsersSimple'
import { calculateAge } from '@/util/person.ts'
import TruncatedText from '@/component/tooltip/TruncatedText.tsx'
import AlertStatusBadge from '@/component/badge/AlertStatusBadge.tsx'
import { useTranslation } from 'react-i18next'
import useQueryGetMe from '@/api/auth/getMe.ts'

export interface IProps extends IUser {
    className?: string
    onClick: (userId: number) => void
}

const SearchUserItem: React.FC<IProps> = ({
    className,
    id,
    alertStatus,
    name,
    birthDate,
    gender,
    onClick
}) => {
    const { t } = useTranslation()
    const { data: me } = useQueryGetMe()

    // 특정 이메일 계정인지 확인
    const isMaskingRequired = useMemo(() => {
        return me?.email === 'dbd_cm@clomental.com'
    }, [me?.email])

    // 마스킹 처리 함수
    const getMaskedName = (name?: string) => {
        if (!isMaskingRequired || !name) return name
        if (name.length <= 1) return name
        return name.charAt(0) + '**'
    }

    const genderName = useMemo(() => {
        if (gender == 0) return t('users.list.item.gender.male')
        if (gender == 1) return t('users.list.item.gender.female')
        else return t('users.list.item.gender.none')
    }, [gender, t])

    return (
        <>
            <div
                className={`${className} flex gap-[10px] justify-between items-center px-[20px] py-[10px] overflow-hidden rounded-[10px] bg-sub_b hover:bg-blue-100 hover:cursor-pointer active:bg-blue-200 `}
                onClick={() => onClick(id)}>
                <AlertStatusBadge value={alertStatus} className={'w-[15px] h-[15px]'} />
                <TruncatedText className={'flex-1 text-center'} text={getMaskedName(name)} />
                <p>
                    {t('users.list.item.age', { count: calculateAge(birthDate) })} / {genderName}
                </p>
            </div>
        </>
    )
}

export default SearchUserItem
